import type { IdTour, PasoTour } from "./tiposTour";

export const EVENTO_SOLICITAR_TOUR = "senciyo:tour" as const;

declare global {
  interface Window {
    __senciyoTourPendiente?: string;
    __senciyoTourPendienteDesdeIndice?: number;
  }
}

export type DetalleSolicitudTour = {
  idTour: IdTour;
  desdeIndice?: number;
};

export interface OpcionesInicioTour {
  /** Índice de paso por el que debe empezar la búsqueda (0 = desde el principio). */
  desdeIndice?: number;
}

export const solicitarInicioTour = (idTour: IdTour, opciones?: OpcionesInicioTour): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.__senciyoTourPendiente = idTour;
  window.__senciyoTourPendienteDesdeIndice = opciones?.desdeIndice;
  window.dispatchEvent(
    new CustomEvent<DetalleSolicitudTour>(EVENTO_SOLICITAR_TOUR, {
      detail: { idTour, desdeIndice: opciones?.desdeIndice },
    })
  );
};

export const EVENTO_CERRAR_TOUR = "senciyo:tour:cerrar" as const;

export const solicitarCierreTour = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(EVENTO_CERRAR_TOUR));
};

export const buscarElementoPaso = (selector: PasoTour["selector"]): HTMLElement | null => {
  if (typeof document === "undefined") {
    return null;
  }
  return document.querySelector<HTMLElement>(selector);
};

export const desplazarElemento = (elemento: HTMLElement): void => {
  elemento.scrollIntoView({ behavior: "instant", block: "center", inline: "center" });
};

export const aplicarResaltado = (_elemento: HTMLElement): void => {
  // El ring del tooltip maneja el encuadre visual — no se modifica el elemento DOM.
};

export const limpiarResaltado = (_elemento?: HTMLElement | null): void => {
  // No hay estilos aplicados que limpiar.
};
